import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  icon: string;
}


const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, description, icon }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalContent" onClick={(e) => e.stopPropagation()}>
        <img src={icon} width={48} height={48} alt={title} />
        <h2>{title}</h2>
        <p>{description}</p>
        <div className="modalButtons">
          <button className='backButton' onClick={onClose}>{t('ok')}</button>
        </div>
      </div>       
    </div>
  );
};

export default Modal;
